var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLikeunselected = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_864_1451",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_864_1451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 39.9999H21.8333V22.6666L31.1666 13.3333L32.8333 14.9999C32.9888 15.1555 33.1166 15.3666 33.2166 15.6333C33.3166 15.8999 33.3666 16.1555 33.3666 16.3999V16.8666L31.9 22.6666H40.5C41.2111 22.6666 41.8333 22.9333 42.3666 23.4666C42.9 23.9999 43.1666 24.6221 43.1666 25.3333V27.9999C43.1666 28.1555 43.1444 28.3221 43.1 28.4999C43.0555 28.6777 43.0111 28.8444 42.9666 28.9999L38.9666 38.3999C38.7666 38.8444 38.4333 39.2221 37.9666 39.5333C37.5 39.8444 37.0111 39.9999 36.5 39.9999ZM24.5 37.3333H36.5L40.5 27.9999V25.3333H28.5L30.3 17.9999L24.5 23.7999V37.3333ZM21.8333 22.6666V25.3333H17.8333V37.3333H21.8333V39.9999H15.1666V22.6666H21.8333Z",
    fill: "#34A853"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLikeunselected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/likeunselected.d0db1d5d.svg";
export { ForwardRef as ReactComponent };